export const PATH_AUTH = {
    login: '/',
};

export const PATH_PAGE = {
    page404: '/404',
};

export const PATH_DASHBOARD = {
    start: '/',
    tournaments: {
        edit: (id) => `/tournaments/edit/${id}`,
        results: (id) => ({
            index: `/tournaments/edit/${id}/results`,
        }),
    },
};
